/**
 * @copyright
 * Copyright(c) 2020 SICK AG
 */

/**
 * A value range
 */

/**
 * The type of a value range
 */
export let ValueRangeScale;

(function (ValueRangeScale) {
  ValueRangeScale["linear"] = "linear";
  ValueRangeScale["log10"] = "log10";
})(ValueRangeScale || (ValueRangeScale = {}));
